export const DEFAULT_PRODUCTS_ORDERS_FEATURES = {
  openConversationLink: true,
  timeline: true,
  advancedStatuses: true,
  quickCreateFromConversation: true,
};

export const DEFAULT_PRODUCTS_ORDERS_CONFIG = {
  paymentMethods: [],
  defaultActions: [],
  webhookUrls: [],
  webhookEvents: [],
  stuckOrderRules: [],
};

export const resolveProductsOrdersFeatures = settings => {
  const rawFeatures =
    settings?.products_orders_features || settings?.productsOrdersFeatures || {};

  return {
    openConversationLink:
      rawFeatures.open_conversation_link ??
      rawFeatures.openConversationLink ??
      DEFAULT_PRODUCTS_ORDERS_FEATURES.openConversationLink,
    timeline:
      rawFeatures.timeline ?? DEFAULT_PRODUCTS_ORDERS_FEATURES.timeline,
    advancedStatuses:
      rawFeatures.advanced_statuses ??
      rawFeatures.advancedStatuses ??
      DEFAULT_PRODUCTS_ORDERS_FEATURES.advancedStatuses,
    quickCreateFromConversation:
      rawFeatures.quick_create_from_conversation ??
      rawFeatures.quickCreateFromConversation ??
      DEFAULT_PRODUCTS_ORDERS_FEATURES.quickCreateFromConversation,
  };
};

export const resolveProductsOrdersConfig = settings => {
  const rawConfig =
    settings?.products_orders_config || settings?.productsOrdersConfig || {};

  return {
    paymentMethods:
      rawConfig.payment_methods ??
      rawConfig.paymentMethods ??
      DEFAULT_PRODUCTS_ORDERS_CONFIG.paymentMethods,
    defaultActions:
      rawConfig.default_actions ??
      rawConfig.defaultActions ??
      DEFAULT_PRODUCTS_ORDERS_CONFIG.defaultActions,
    webhookUrls:
      rawConfig.webhook_urls ??
      rawConfig.webhookUrls ??
      DEFAULT_PRODUCTS_ORDERS_CONFIG.webhookUrls,
    webhookEvents:
      rawConfig.webhook_events ??
      rawConfig.webhookEvents ??
      DEFAULT_PRODUCTS_ORDERS_CONFIG.webhookEvents,
    stuckOrderRules:
      rawConfig.stuck_order_rules ??
      rawConfig.stuckOrderRules ??
      DEFAULT_PRODUCTS_ORDERS_CONFIG.stuckOrderRules,
  };
};
